import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Card, CardContent } from '@mui/material';

import DividerHorizontal from '../../../components/common/DividerHorizontal';
import { ActionButtons } from '../../../components/others/ActionButtons';
import { AssociateActions } from '../components/AssociateActions';
import { CreateGroup } from '../components/CreateGroup';
import { useManageGroup } from '../hooks/useManageGroup';

export const LayoutGroup = () => {
    const navigate = useNavigate();
    const [managerGroup] = useManageGroup();
    const {
        values,
        errorInputs,
        dataActions,
        companiesSelect,
        t,
        handleInputChange,
        handleDirectInputChange,
        reset,
        validateForm,
        save
    } = managerGroup

    const handleSave = () => {
        if (validateForm()) {
            save(values);
            handleCancel();
        }
    };

    const handleCancel = () => {
        reset();
        navigate(-1);
    };

    return (
        <Box sx={{ mx: 'auto' }}>
            <Card sx={{ mb: 3 }}>
                <CardContent>
                    <CreateGroup
                        values={values}
                        companies={companiesSelect}
                        errorInputs={errorInputs}
                        t={t}
                        handleInputChange={handleInputChange}
                    />

                    <DividerHorizontal />

                    <AssociateActions
                        values={values.access}
                        data={dataActions}
                        t={t}
                        handleDirectInputChange={handleDirectInputChange}
                    />

                    <Box sx={{ textAlign: 'right', mt: 4 }}>
                        <ActionButtons
                            onCancel={handleCancel}
                            onSubmit={handleSave}
                        />
                    </Box >
                </CardContent >
            </Card >
        </Box >
    )
};
